import React from 'react';
import { IconColorsWrapper } from './IconColorsWrapper';

const AscendingClockIcon = props => {
  return (
    <IconColorsWrapper>
      <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
          fill={props?.fill || 'currentColor'}
          d="M20 17h3l-4 4l-4-4h3V3h2v14M8 5c-3.86 0-7 3.13-7 7s3.13 7 7 7c3.86 0 7-3.13 7-7s-3.13-7-7-7m0 2.15c2.67 0 4.85 2.17 4.85 4.85c0 2.68-2.17 4.85-4.85 4.85c-2.68 0-4.85-2.17-4.85-4.85c0-2.68 2.17-4.85 4.85-4.85M7 9v3.69l3.19 1.84l.75-1.3l-2.44-1.41V9"
        ></path>
      </svg>
    </IconColorsWrapper>
  );
};
export { AscendingClockIcon };
